import { useEffect, useState } from 'react';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { useWorkspaces } from '@Hooks/useWorkspaces';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import WorkspaceCard from '@Components/WorkspaceCard';

const INITIAL_LIMIT = 4;

export default function WorkspacePreview() {
  const [showAll, setShowAll] = useState(false);

  const {
    data: workspaces,
    isError,
    error,
    isLoading,
  } = useWorkspaces({
    searchParams: {
      include: 'dashboards.dashboard',
    },
  });

  useEffect(() => {
    if (isError && error) {
      toastError(
        error instanceof Error ? error.message : 'Failed to load Workspaces',
      );
    }
  }, [isError, error]);

  const allWorkspaces = workspaces?.data ?? [];
  const hasMore = allWorkspaces.length > INITIAL_LIMIT;
  const visible = showAll
    ? allWorkspaces
    : allWorkspaces.slice(0, INITIAL_LIMIT);

  if (isLoading || !allWorkspaces.length) return null;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full justify-center">
        <span className="text-3xl">Workspaces</span>
      </div>
      <div className="grid grid-cols-4 gap-6">
        {visible.map((ws) => {
          return <WorkspaceCard key={ws.id} workspace={ws} />;
        })}
      </div>

      {hasMore && (
        <div className="flex justify-center">
          <Button
            variant="secondary"
            onClick={() => setShowAll((prev) => !prev)}
          >
            {showAll ? 'Hide' : `Show all (${allWorkspaces.length})`}
          </Button>
        </div>
      )}
    </div>
  );
}
